var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22723_239873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8.46005V9.96005C11.0006 10.0993 10.9721 10.2371 10.9163 10.3647C10.8605 10.4923 10.7787 10.6068 10.6761 10.701C10.5735 10.7951 10.4523 10.8668 10.3204 10.9114C10.1885 10.956 10.0487 10.9726 9.91003 10.96C8.37144 10.7929 6.89353 10.2671 5.59503 9.42505C4.38694 8.65738 3.3627 7.63313 2.59503 6.42505C1.75002 5.12065 1.22415 3.63555 1.06003 2.09005C1.04753 1.95178 1.06397 1.81243 1.10828 1.68086C1.15259 1.54929 1.22381 1.42839 1.31741 1.32586C1.41101 1.22332 1.52493 1.1414 1.65192 1.08531C1.77892 1.02922 1.9162 1.00018 2.05503 1.00005H3.55503C3.79768 0.99766 4.03292 1.08359 4.21691 1.24181C4.40089 1.40004 4.52107 1.61977 4.55503 1.86005C4.61834 2.34008 4.73575 2.81141 4.90503 3.26505C4.9723 3.44401 4.98686 3.63851 4.94698 3.82549C4.9071 4.01247 4.81446 4.1841 4.68003 4.32005L4.04503 4.95505C4.75681 6.20682 5.79325 7.24327 7.04503 7.95505L7.68003 7.32005C7.81597 7.18562 7.9876 7.09297 8.17459 7.0531C8.36157 7.01322 8.55607 7.02778 8.73503 7.09505C9.18866 7.26432 9.65999 7.38174 10.14 7.44505C10.3829 7.47931 10.6047 7.60165 10.7633 7.7888C10.9219 7.97594 11.0061 8.21484 11 8.46005Z",
    stroke: "#62748E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22723_239873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4817ebe0d5fd9596a724909543533641.svg";
export { ForwardRef as ReactComponent };